import { NavLink, useNavigate } from "react-router-dom";
import { Users, UsersRound, CalendarDays, Sun, Moon } from "lucide-react";
import { useAuth } from "../shared/AuthContext";
import { useRole } from "../shared/RoleContext";
import ConsoleSwitcher from "../shared/ConsoleSwitcher";
// Reuses the client portal's sidebar styles (.client-sidebar*) — generic
// rail primitives, not client-specific.
import "../client/Sidebar.css";

export default function CoachSidebar({ theme, onToggleTheme }) {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const { role } = useRole();

  // 2+ teams -> "Teams" (matches iOS's dynamic tab label); 0/1 -> "Players",
  // same as every coach saw before multi-team support.
  const isMultiTeam = (role?.teamCount || 0) > 1;
  const nav = [
    { to: "/coach", end: true, label: isMultiTeam ? "Teams" : "Players", icon: isMultiTeam ? UsersRound : Users },
    { to: "/coach/games", label: "Games", icon: CalendarDays },
  ];

  const handleSignOut = async () => {
    try {
      localStorage.removeItem("polyp_role");
    } catch {}
    await signOut();
    navigate("/logged-out", { replace: true });
  };

  const displayName = role
    ? `${role.firstName || ""} ${role.lastName || ""}`.trim() || role.email
    : "";

  return (
    <aside className="client-sidebar">
      <div className="client-sidebar-brand">Polyp</div>

      <nav className="client-sidebar-nav">
        {nav.map(({ to, end, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `client-sidebar-link${isActive ? " active" : ""}`
            }
          >
            <Icon size={18} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <ConsoleSwitcher />

      <div className="client-sidebar-foot">
        {displayName ? (
          <div className="client-sidebar-user">
            <div>
              <div className="client-sidebar-user-name">{displayName}</div>
              <div className="client-sidebar-user-sub">{role?.teamName || role?.email}</div>
            </div>
          </div>
        ) : null}

        <button className="client-sidebar-theme" onClick={onToggleTheme}>
          {theme === "light" ? <Moon size={14} /> : <Sun size={14} />}
          <span>{theme === "light" ? "Dark" : "Light"} mode</span>
        </button>

        <button className="client-sidebar-signout" onClick={handleSignOut}>
          Sign out
        </button>
      </div>
    </aside>
  );
}
